// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.job-order-activity-timeline[data-v-8e8b31b4] {\n    padding: 8px 8px 0 4px;\n}\n.job-order-activity-card[data-v-8e8b31b4] {\n    border: 1px solid #e4e7ed;\n    border-radius: 4px;\n}\n.job-order-activity-reason[data-v-8e8b31b4] {\n    padding: 7px 10px;\n    background: #fff8e1;\n    border-left: 3px solid #e6a23c;\n    color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
